import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { onSuccessHandler, onErrorHandler } from './handlers';
import { ShippingMethodOperations } from '../enums/shippingOperation';
import { config } from '../utils/config';
import { currencyFormatter } from '../utils/currency';
import { startLoading } from './application';

declare const window: any;

export const shippingMethodApi = createApi({
    reducerPath: 'shippingMethodApi',
    baseQuery: fetchBaseQuery({
        baseUrl: window.Config?.GET_NA_SHIPPING_METHOD ?? "https://npr-na-shipping.api.pens.com",
        prepareHeaders: (headers) => {
            headers.set(window.Config?.NP_API_KEY_HEADER_NAME ?? "x-api-key", window.Config?.NP_API_KEY_CLIENT_JS ?? "NSjMi38PBJ6s1rvNMA9FKO6FRn2iDd95bEDoaij8")
            return headers
        },
    }),
    tagTypes: ['ShippingMethod'],
    endpoints: (builder) => ({
        getShippingMethod: builder.query({
            query: (data) => ({
                url : `v1/shipMethods`,
                method: 'GET',
                params: data
            }),
            async onQueryStarted(obj, { dispatch, getState, queryFulfilled }) {
                dispatch(startLoading());
                try{
                    const {data} = await queryFulfilled;
                    let fetchedNaPrices = data;
                    const shippingMethods = config('shippingMethods') ? JSON.parse(config('shippingMethods')) : [];

                    if(fetchedNaPrices && fetchedNaPrices.shippingMethods) {
                        for(let i = 0; i < fetchedNaPrices.shippingMethods.length; i++) {
                            for(let j = 0; j < shippingMethods.length; j++) {
                                if(fetchedNaPrices.shippingMethods[i].name === shippingMethods[j].key) {
                                    shippingMethods[j].methodPrice = currencyFormatter(fetchedNaPrices?.shippingMethods[i]?.price);
                                }
                            }
                        }
                    }
                    dispatch(onSuccessHandler(ShippingMethodOperations.GET_NA_SHIPPING_PRICES, {shippingMethods : shippingMethods}));
                    dispatch(shippingMethodApi.util.invalidateTags(['ShippingMethod']));
                }
                catch(error){
                    console.log(error);
                    dispatch(onErrorHandler({operation: ShippingMethodOperations.GET_NA_SHIPPING_PRICES, err: JSON.stringify(error), errMsg: 'Error: while getting shipping methods', api: 'v1/shipMethods'}));
                }
            },
        }),
    }),
})

export const {useGetShippingMethodQuery} = shippingMethodApi;